import { RouteObject } from 'react-router'
import burnoutInsightRoutes from './burnoutInsights/routes'
import flaggedContentRoutes from './flaggedContent/routes'
import kudosTvRoutes from './kudosTv/routes'

const routes: RouteObject[] = [...burnoutInsightRoutes, ...flaggedContentRoutes, ...kudosTvRoutes]

export default routes
